import { useEffect, useState } from "react";
import ToggleButton from "../../ui/button/toggleButton";
import styles from "./styles.module.scss";
import Button from "../../ui/button";
import PersonalInfo from "./personalInfo";
import Card from "../../ui/card";
import UserDeal from "./deals";
import localStorageServices, {
  getAccessToken,
} from "../../../lib/services/localStorage.service";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../shared/constants";
import ConfirmModal from "../../shared/modals/confirmModal";
import useOpenModal from "../../ui/modal/hooks/useOpenModal";

export type TToggleButton = "personalData" | "deals";

const My = () => {
  const [toggleButton, setToggleButton] = useState<TToggleButton>("deals");
  const isAuth = getAccessToken();

  const { offsetY, open, handleChangeModal } = useOpenModal();

  const handleOpenModal = (value: boolean) => {
    handleChangeModal(value);
  };

  const handleToggleButton = (data: TToggleButton) => {
    setToggleButton(data);
  };

  const navigate = useNavigate();

  const navigateAuth = () => {
    navigate(`/${PATHS.auth}`);
  };

  useEffect(() => {
    if (!isAuth) {
      navigateAuth();
    }
  }, []);

  const handleLogOut = () => {
    localStorageServices.removeAuthData();
    navigateAuth();
  };

  return (
    <div className={styles.my}>
      {isAuth && (
        <div className={styles.my__container}>
          <div className={styles.my__buttons}>
            <ToggleButton
              isNoneFlex={window.innerWidth > 600}
              data={[
                <Button
                  label="Заявки"
                  onClick={() => handleToggleButton("deals")}
                  variant={toggleButton === "deals" ? "default" : "gray"}
                />,
                <Button
                  label="Личный кабинет"
                  onClick={() => handleToggleButton("personalData")}
                  variant={toggleButton === "personalData" ? "default" : "gray"}
                />,
              ]}
            />
            <div className={styles.my__logOut}>
              <Button
                onClick={(event) => handleOpenModal(true)}
                label="Выйти"
                variant="danger"
              />
            </div>
          </div>

          <div className={styles.my__form}>
            <Card>
              {toggleButton === "deals" ? <UserDeal /> : <PersonalInfo />}
            </Card>
          </div>

          <ConfirmModal
            opened={open}
            offsetY={offsetY}
            onClose={(value) => handleOpenModal(value)}
            onClickRight={handleLogOut}
            title="Выйти"
            text="Вы уверены что хотите выйти?"
          />
        </div>
      )}
    </div>
  );
};

export default My;
